export class MappingModel {
    constructor(
        public userroleid: any,
        public page_id: number,
    ) { }
}
